import get from 'lodash/get';
import find from 'lodash/find';
import { ALLSEATS } from '../../Constants/SeatPositions';

export const getSelectedStage = ({ configurator: { selectedStage } }) => selectedStage;

export const getOptionColors = (option) =>
  get(find(option?.attributes, { identifier: 'fabric_color' }), 'values', []);

export const isAllSeatsSelected = (configuration) => {
  const seatPositionQuestion = find(get(configuration, 'customdata.seatData'), {
    identifier: 'seat_position',
  });
  return seatPositionQuestion?.selectedAnswer === ALLSEATS;
};
